import React, { useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const FlashMessages = ({ messages }) => {
  useEffect(() => {
    if (messages) {
      messages.forEach(({ type, message }) => {
        switch (type) {
          case 'notice':
          case 'success':
            toast.success(message);
            break;
          case 'alert':
          case 'error':
          case 'danger':
            toast.error(message);
            break;
          case 'warning':
            toast.warn(message);
            break;
          default:
            toast.info(message);
        }
      });
    }
  }, [messages]);

  return <ToastContainer position="top-center" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />;
};

export default FlashMessages;
